/* eslint-disable global-require */
module.exports = [...require('../common/Form/i18n'), 'payments.informations.m1', 'payments.informations.m2', 'payments.proforma.m1', 'payments.proforma.m2', 'payments.proforma.m3'];
